import { useMutation } from "react-query";
import { useApi } from "../useApi";

interface UploadFileRequest {
  file: File;
}

export function useUploadFile() {
  const { api } = useApi();

  return useMutation(async (data: UploadFileRequest) => {
    const formData = new FormData();
    formData.append("file", data.file);

    return api.post(`/platform/file-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  });
}
